module.exports = __webpack_public_path__ + "img/icon13.fa732555.png";